export enum postFilterTypes {
  ALL = 'all',
  UNREAD = 'unread',
  MARKED = 'marked',
  EMPLOYEES = 'employees',
  PARENTS = 'parents',
  STUDENTS = 'students',
  OWN_POST = 'ownPost',
}
